// extracted by mini-css-extract-plugin
export default {"container":"ZO9FJ","link":"ZgsAo","title":"WaHkY","icon":"rmgq1","popup":"iwzS1","calculator":"lpBe9","descriptions":"MUGkF"};